import * as actions from '../actions/slotsActions';

const initialState = {
  games: [],
};

export default function slots(state = initialState, action) {
  switch (action.type) {
    case actions.SET_GAMES: {
      return {
        ...state,
        games: action.games,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/slots.js